var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Twitter_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8 0H3.2C1.43269 0 0 1.43269 0 3.2V28.8C0 30.5673 1.43269 32 3.2 32H28.8C30.5673 32 32 30.5673 32 28.8V3.2C32 1.43269 30.5673 0 28.8 0ZM24.5603 9.98298C25.4899 9.87553 26.3755 9.63729 27.2 9.28328C26.584 10.1737 25.8044 10.9559 24.9058 11.5831C24.9144 11.7739 24.9187 11.9655 24.9187 12.1579C24.9187 18.0296 20.2976 24.8 11.8445 24.8C9.24881 24.8 6.83401 24.0645 4.8 22.8042C5.16011 22.8458 5.52625 22.8667 5.8967 22.8667C8.05046 22.8667 10.0319 22.1561 11.6042 20.9641C9.59342 20.9283 7.89625 19.643 7.31129 17.878C7.59128 17.9288 7.87988 17.9571 8.17538 17.9571C8.59493 17.9571 9.00156 17.9029 9.38665 17.8013C7.28372 17.394 5.70027 15.5981 5.70027 13.4448V13.389C6.3197 13.7214 7.02871 13.9213 7.78167 13.9446C6.54886 13.1483 5.73818 11.788 5.73818 10.247C5.73818 9.43155 5.96476 8.66854 6.35932 8.01215C8.62681 10.701 12.0125 12.4703 15.8316 12.6552C15.754 12.3311 15.7127 11.9913 15.7127 11.6431C15.7127 9.18999 17.77 7.2 20.308 7.2C21.6295 7.2 22.8236 7.73977 23.6618 8.60357C24.7094 8.40365 25.6932 8.03381 26.5806 7.52486C26.2377 8.56275 25.5097 9.43322 24.5603 9.98298Z",
    fill: "#706458",
    fillOpacity: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.0b90b17ddb23cdc27bd2d454a36f6005.svg";
export { ForwardRef as ReactComponent };